import { stock } from '@/data/stockImages';

// Doğrudan cevap (A). Hedef: qr menü nedir, qr menü nasıl çalışır, kafe/restoran qr menü.
export default [
  {
    t: 'p',
    text: 'QR menü (karekod menü), masadaki bir QR kodu telefon kamerasıyla okutunca açılan dijital menüdür. Müşteri bir uygulama indirmez; kod, tarayıcıda işletmenin menü sayfasını açar. Ürünler, fiyatlar ve varsa fotoğraf ve açıklamalar bu sayfada listelenir. Bazı sistemlerde müşteri aynı sayfadan sipariş de verebilir.',
  },
  {
    t: 'p',
    text: 'Aşağıda QR menünün nasıl çalıştığını, basılı menüye göre neyi değiştirdiğini ve kafe ile restoranda nasıl kullanıldığını anlatıyoruz. Kurulum adımlarını merak ediyorsanız [QR menü nasıl oluşturulur](/blog/qr-menu-nasil-olusturulur) yazısına geçebilirsiniz.',
  },
  { t: 'h2', text: 'QR menü nasıl çalışır?' },
  {
    t: 'img',
    img: stock('qr-menu-telefon', 'Telefon ekranında kategorilere ayrılmış QR menü'),
  },
  {
    t: 'p',
    text: 'QR kod aslında bir bağlantının karekod hâlidir. Müşteri kamerayı koda tuttuğunda telefon bağlantıyı tanır ve menü sayfasını açar. Menünün içeriği kodun içinde değil, bağlantının gösterdiği sayfadadır. Bu yüzden menüyü değiştirdiğinizde masadaki kodu değiştirmeniz gerekmez; aynı kod güncel menüyü açar.',
  },
  {
    t: 'p',
    text: 'Menü sayfası iki şekilde hazırlanabilir. Birincisi, basılı menünün PDF’ini ya da fotoğrafını yüklemek. İkincisi, ürünleri bir yazılıma tek tek girip menünün telefona göre düzenlenmiş bir sayfa olarak oluşturulmasını sağlamak. İlki kolaydır ama telefonda yakınlaştırarak okunur; ikincisinde müşteri kategoriler arasında gezinir, arama yapar, ürün ayrıntısını açar.',
  },
  { t: 'h2', text: 'Basılı menüye göre farkı' },
  {
    t: 'table',
    head: ['', 'Basılı menü', 'QR menü'],
    rows: [
      ['Fiyat değişikliği', 'Yeniden baskı gerekir', 'Panelden değişir, anında yansır'],
      ['Tükenen ürün', 'Garson sözlü söyler', 'Menüden gizlenebilir'],
      ['Ürün ayrıntısı', 'Sayfaya sığdığı kadar', 'Fotoğraf, içerik, kalori, alerjen'],
      ['Hijyen ve yıpranma', 'Elden ele geçer, yıpranır', 'Müşterinin kendi telefonunda açılır'],
      ['Sipariş', 'Garsona söylenir', 'Sistem destekliyorsa menüden verilebilir'],
    ],
  },
  {
    t: 'p',
    text: 'QR menü basılı menüyü tamamen ortadan kaldırmaz. Telefonu yanında olmayan ya da basılı menüyü tercih eden müşteriler her zaman olur. Ekim 2025’te Fiyat Etiketi Yönetmeliği’nde yapılan değişiklikle fiyat listesinin masalarda karekodla sunulmasına açıkça imkân tanındı; müşteri talep ettiğinde basılı menü verilmesi ise gerekiyor. Birkaç basılı menüyü tezgâhta hazır tutmak iki durumu da karşılar.',
  },
  { t: 'h2', text: 'QR menüde hangi bilgiler yer alır?' },
  {
    t: 'p',
    text: 'En temel hâliyle ürün adı ve fiyatı yeterlidir. Yazılımla hazırlanan menülerde bunlara ek olarak şu bilgiler gösterilebilir:',
  },
  {
    t: 'list',
    items: [
      '**Fotoğraf ve açıklama:** Özellikle adı ne olduğunu anlatmayan ürünlerde müşterinin karar vermesini kolaylaştırır.',
      '**İçerik ve alerjen bilgisi:** Gluten, süt ürünü ya da kuruyemiş hassasiyeti olan müşteriler garsona sormadan kontrol edebilir.',
      '**Kalori:** Her işletme göstermek istemez; ürün bazında açılıp kapatılabilmesi işe yarar.',
      '**Alkol bilgisi:** Alkollü ürünlerin ayrıca işaretlenmesi ve filtrelenebilmesi, özellikle aile müşterisi olan mekânlarda kullanışlıdır.',
    ],
  },
  {
    t: 'guide',
    image: '17-qr-menu',
    alt: 'Müşterinin telefonunda açılan, kategorilere ayrılmış QR menü',
    caption: 'Tilki QR menüsü: kategoriler, arama ve popüler, alerjensiz, alkolsüz filtreleri.',
  },
  { t: 'h2', text: 'Sadece menü mü, sipariş de mi?' },
  {
    t: 'p',
    text: 'QR menüler iki gruba ayrılır. **Görüntüleme amaçlı** menüde müşteri menüye bakar, siparişi garsona verir. **Siparişli** menüde müşteri ürünleri sepete ekleyip masa numarasıyla gönderir; sipariş işletmenin sistemine düşer.',
  },
  {
    t: 'p',
    text: 'Siparişli menü, yoğun saatlerde garsonun masaya ilk gelişini beklemeyi azaltır ve ikinci siparişi (bir kahve daha, tatlı) kolaylaştırır. Ancak her mekâna uymaz: masada sohbet ederek sipariş vermeyi seven müşteri kitlesi olan ya da servisini öne çıkaran restoranlar menüyü görüntüleme amaçlı tutmayı tercih edebilir. Siparişli menü seçilirse gelen siparişin personel tarafından onaylanması, yanlış masa ve hatalı siparişlerin önüne geçer. Akışın ayrıntısını [QR kod ile masadan sipariş](/blog/qr-kod-ile-masadan-siparis) yazısında anlattık.',
  },
  { t: 'h2', text: 'Kafe ve restoranda kullanım farkı' },
  {
    t: 'p',
    text: 'Kafelerde QR menü çoğunlukla hız için kullanılır: menü kısadır, müşteri ne istediğini bilir, tekrar sipariş sık verilir. Tek bir QR kod bütün masalar için yeterli olabilir. Restoranlarda ise menü uzundur ve müşteri ürün ayrıntısına daha çok bakar; fotoğraf, porsiyon açıklaması ve alerjen bilgisi burada daha fazla iş görür. Masadan sipariş alınacaksa her masaya ayrı kod koymak, masa numarasının otomatik tanınmasını sağlar.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da QR menü' },
  {
    t: 'p',
    text: 'Tilki’de QR menü, panele girdiğiniz ürünlerden otomatik oluşur; ayrı bir menü hazırlamazsınız. Online siparişi açıp kapatmak, müşterinin açık hesabını menüden görmesine izin vermek ve bir ürünü menüden gizlemek panelden birer ayardır. Ekran görüntüleriyle anlatım [kullanım rehberinin QR menü bölümünde](/nasil-kullanilir#qr-menu).',
  },
  {
    t: 'cta',
    title: 'QR menünüzü görmek ister misiniz?',
    text: 'Ücretsiz demo talep edin; kendi ürünlerinizle hazırlanmış menüyü birlikte inceleyelim.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'QR menü fiyatları ne kadar?',
    a: 'Menünün PDF’ini bir QR koda bağlamak ücretsiz yapılabilir. Ürünlerin tek tek girildiği, masadan sipariş ve filtre sunan QR menü yazılımları ise genellikle aylık abonelikle sunulur. Tilki Otomasyon’da QR menü ayrıca ücretlendirilmez; tüm modüllerle birlikte [aylık plana](/fiyatlar) dahildir.',
  },
  {
    q: 'QR menüyü açmak için uygulama indirmek gerekir mi?',
    a: 'Hayır. Güncel telefonların çoğunda kamera uygulaması QR kodu doğrudan okur ve menü tarayıcıda açılır. Müşterinin ayrıca bir uygulama indirmesi gerekmez.',
  },
  {
    q: 'QR menü internetsiz çalışır mı?',
    a: 'Hayır. Menü bir web sayfası olduğu için müşterinin telefonunda mobil veri ya da Wi-Fi bağlantısı olmalıdır. Çekimin zayıf olduğu mekânlarda misafir Wi-Fi bilgisini QR kodun yanına yazmak işe yarar.',
  },
  {
    q: 'Basılı menüyü tamamen kaldırabilir miyim?',
    a: 'Önerilmez. Fiyat Etiketi Yönetmeliği’ndeki 2025 değişikliğiyle masalarda karekodla fiyat listesi sunulabiliyor, ancak müşteri istediğinde basılı menü verilmesi gerekiyor. Birkaç basılı menüyü hazır tutmak yeterli olur.',
  },
];
